// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1bMMe","search":"Settings_search__1BRfj","filter":"Settings_filter__1Q6sw"};